import assetsData from "./assetsData";
const INITIAL_STATE = {
  devices: null,
  assets: assetsData,
  isFetching: false,
  errors: [],
  IdDeviceToTrack:null
};

const assetsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_DEVICES_START":
      return {
        ...state,
        isFetching: true,
      };
    case "GET_ALL_DEVICES_SUCCESS":
      return {
        ...state,
        isFetching: false,
        devices: action.payload,
      };
    case "GET_ALL_DEVICES_FAILURE":
      return {
        ...state,
        isFetching: false,
        errors: [action.payload, ...state.errors],
      };
    case "ASSIGN_SPEED_LIMIT_REQUEST":
      return { ...state, isFetching: true, errors: [] };

    case "ASSIGN_SPEED_LIMIT_SUCCESS":
      return {
        ...state,
        isFetching: false,
      };
    case "ASSIGN_SPEED_LIMIT_FAILURE":
      return {
        ...state,
        isFetching: false,
        errors: state.errors.concat(action.payload),
      };

    case "SET_GEOFENCES_TO_DEVICE":
      return {
        ...state,
        devices: state.devices.map((device) => {
          if (action.payload.devices.includes(device._id)) {
            return {
              ...device,
              geofences: device.geofences.includes(action.payload.geofence)
                ? device.geofences
                : device.geofences.concat(action.payload.geofence),
            };
          }

          return device;
        }),
      };

    case "DELETE_GEOFENCES_FROM_DEVICE":
      return {
        ...state,
        devices: state.devices.map((device) => {
          if (device._id === action.payload.device) {
            const updatedGeofences = device.geofences.filter(
              (geofenceId) => geofenceId !== action.payload.geofence
            );

            return {
              ...device,
              geofences: updatedGeofences,
            };
          }

          return device;
        }),
      };

    case "REFRESH_DEVICES_SPEED_LIMIT":
      return {
        ...state,
        devices: state.devices.map((device) => {
          if (device._id === action.payload.deviceId) {
            const updatedDevice = {
              ...device,
              speedLimit: action.payload.speedLimit,
            };
            return updatedDevice;
          } else return device;
        }),
      };
    case "CHANGE_DEVICE_LOCATION":
      return{
        ...state,
        devices: state.devices.map((device) => {
          if (device._id === action.payload.deviceId) {
            const updatedDevice = {
             ...device,
              locations: [action.payload.location],
            };
            return updatedDevice;
          } else return device;
        }),
      }
    case "TRACK_DEVICE": 
    return {
      ...state, IdDeviceToTrack:action.payload 
    }
    default:
      return state;
  }
};

export default assetsReducer;
